import { v4 } from 'uuid'

import { FormItemDraggableBase } from './form-item-draggable-base'
import { IconEnum } from '../../../../../assets/icons'
import { FormItemType } from '../../constants/form-builder.constants'

export const TextareaDraggable = () => {
  const id = v4()
  const type = FormItemType.Textarea

  return (
    <FormItemDraggableBase
      icon={IconEnum.Text}
      id={id}
      title="formBuilder.textareaField"
      type={type}
    />
  )
}
